module.exports = __webpack_public_path__ + "img/Logo-Universidad-hvac.d01a8cc3.png";